/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { getFeedConfig } from '../containers/actions/feeds_actions_new';
import { updateConfiguration, updateConfigs, updateOtherConfigs, updateUserConfigs } from '../redux/UserSessionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployeePermissions } from '../containers/actions/employee_actions';
import { getResourceAccessSettings } from '../containers/actions/resource_configuration/access_settings';

const useGetConfigs = () =>
{
	const dispatch = useDispatch();
	const userData = useSelector((state: any) => state?.mysession?.session);
	const getResourcePermissions = async () =>
	{
		let employeePermissions;

		try
		{
			employeePermissions = await getEmployeePermissions(userData?.userId, userData?.companyId);
		}
		catch (error)
		{
			console.log('error', error);
			employeePermissions = { };
		}
		dispatch(updateConfiguration({ type: 'user', data: { employeePermissions: { ...(employeePermissions?.data?.employeePermission ?? {}) } } }));
	};
	const getConfigurations = async (type) =>
	{
		try
		{
			const queryParams = { type };
			const res = await getFeedConfig(queryParams);

			if (res?.status && res?.data)
			{
				dispatch(updateConfiguration({ type, data: { ...(res?.data ?? {}) } }));
			}
			else
			{
				// eslint-disable-next-line no-console
				console.log('error', res);
			}
		}
		catch (error)
		{
			// eslint-disable-next-line no-console
			console.log('error', error);
		}
	};

	const getContentConfiguration = async () =>
	{
		try
		{
			if (!userData?.companyId) return;

			const response = await getResourceAccessSettings(userData.companyId);

			if (response.success)
			{
				dispatch(updateConfiguration({ type: 'company', data: { contentManagement: { ...response.data } } }));
			}
			else
			{
				dispatch(updateConfiguration({ type: 'company', data: { contentManagement: {} } }));
				console.log('No resource configuration data received');
			}
		}
		catch (error)
		{
			dispatch(updateConfiguration({ type: 'company', data: { contentManagement: {} } }));
			console.error('Error fetching resource configuration:', error);
		}
	};

	const getCompanyConfigurations = async () =>
	{
		await getConfigurations('company');
		await getContentConfiguration();
	};
	const getUserConfigurations = () =>
	{
		getConfigurations('user');
		getResourcePermissions();
	};

	const getOtherConfiguration = async (userId) =>
	{
		try
		{
			const queryD = {
				type : 'other',
				id   : userId
			};
			const res = await getFeedConfig(queryD);

			if (res?.status)
			{
				dispatch(updateOtherConfigs(res?.data));
			}
			else
			{
				dispatch(updateOtherConfigs({}));
				console.log('error', res);
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	return { getCompanyConfigurations, getUserConfigurations, getOtherConfiguration, getContentConfiguration };
};

export default useGetConfigs;